import React, {Component} from 'react';
import DatePicker from "react-datepicker";

class Datepicker extends Component {

    constructor(props) {
        super(props);

        this.state = {
            date: new Date(this.props.date)
        };
    }

    handleChange(date) {
        // console.log("Datepicker::handleChange()");
        if(!date) date = new Date()
        this.setState({
            date: date
        });

        if (this.props.handleChange) {
            this.props.handleChange(date);
        }
    }

    render() {
        return (
            <div className={"date-picker"}>
                <DatePicker
                    showIcon={false}
                    selected={this.state.date}
                    onChange={this.handleChange.bind(this)}
                    // locale={this.props.locale ? this.props.locale : "es-ES"}
                    dateFormat="dd-MM-yyyy"
                    // todayButton={this.props.todayButton ? this.props.todayButton : ""}
                    placeholderText={this.props.placeholderText ? this.props.placeholderText : ""}
                    peekNextMonth={false}
                    showMonthDropdown={false}
                    showYearDropdown={false}
                    // dropdownMode="select"
                    disabled={this.props.disabled}
                />
            </div>
        );
    }

}

export default Datepicker;